import type { DiamModifierValues } from '../../diamApi';
import { CreateTeamSubmitPayload } from './types';

export interface DiamTeamCreateRequest {
  parentId: string;
  name: string;
  applicationContextIds: string[];
  modifiers: DiamModifierValues;
}

export interface DiamTeamUpdateRequest {
  name: string;
  modifiers: DiamModifierValues;
}

function mapTeamModifiers(
  payload: Pick<
    CreateTeamSubmitPayload,
    'account' | 'locationIds' | 'optionalModifiers'
  >,
): DiamModifierValues {
  const modifiers: DiamModifierValues = {};

  if (payload.account) {
    modifiers.account = payload.account;
  }

  const locationId = payload.locationIds.find(Boolean);
  if (locationId) {
    modifiers.location = locationId;
  }

  Object.entries(payload.optionalModifiers).forEach(([key, value]) => {
    if (typeof value === 'string' && value.trim()) {
      modifiers[key] = value.trim();
    }
  });

  return modifiers;
}

export function mapCreateTeamApiRequest(
  payload: CreateTeamSubmitPayload,
): DiamTeamCreateRequest {
  return {
    parentId: payload.parentTeamId,
    name: payload.name,
    applicationContextIds: payload.applications,
    modifiers: mapTeamModifiers(payload),
  };
}

export function mapUpdateTeamApiRequest(
  payload: CreateTeamSubmitPayload,
): DiamTeamUpdateRequest {
  return {
    name: payload.name,
    modifiers: mapTeamModifiers(payload),
  };
}
